import SectionCasinoGameBox from "components/casino/section_casino_game_box";
import LayoutMaster from "components/layout/layout_master";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";
import { GetAllGamesResponseResult } from "lib/worker/api/get_all_game";
import get_all_game_promotion_only from "lib/worker/api/get_all_game_promotion_only";
import { GetServerSideProps } from "next";
import { AppReducerStateProps } from "lib/store";
import { connect } from "react-redux";
import { Badge, ProgressBar } from "react-bootstrap";
import get_all_content_by_prefix, {
  GetAllContentByPrefixResponse,
} from "lib/worker/api/get_all_content_by_prefix";
import {
  CONTENT_TYPE_ID_CONTENT_OTHER,
  CONTENT_HTML_TITLE_GAME_BOUNES,
} from "lib/all_type/content_type_id";

export interface SectionTypeGamesProps {
  title: string | undefined;
  toggleState: number;
  pic?: string | undefined;
  bg?: string | undefined;
  flag?: string | undefined;
  flagtitle?: string | undefined;
}

interface Props {
  gamepromotions: GetAllGamesResponseResult[];
  titlepromo: string | undefined;
  state: AppReducerStateProps;
  content: GetAllContentByPrefixResponse[];
  infomation: CheckWithPrefixResponse;
}

function GameConditionPromotion(props: Props) {
  const { gamepromotions, content } = props;

  const DisplayMainConent = () => {
    return (
      <>
        <div
          className="card card-ufa-category color-font-card"
          style={{ padding: 20, marginTop: 20 }}
        >
          <div className="font-bold">
            <h4>
              <span>เกมติดโปรโมชั่นคืออะไร</span>
            </h4>
          </div>
          <p className="bottom-line-yellow"></p>
          <p>
            เกมสำหรับสมาชิกที่สมัครโปรโมชั่น โดยต้องทำ{" "}
            <span>เทิร์นโอเวอร์</span> ให้ถึงที่กำหนดในแต่ละโปรโมชั่น
            โดยทางเราได้เตรียมเกมยอดนิยมในแต่ละค่ายมาไว้ให้สำหรับท่านแล้ว
          </p>
          <li>
            สำหรับสมาชิกที่รับโบนัสจะสามารถเล่นเกมได้ในหน้าเมนู{" "}
            <span>เกมโบนัส</span> เท่านั้น
          </li>
          <li>สมาชิกรับโบนัสเล่นสล็อต ไม่สามารถซื้อฟรีเกม และ บาคาร่าได้</li>
          <li>ในกรณีที่สมาชิกทำผิดกติกา จะไม่สามารถถอนได้</li>
          <li className="font-red font-bold">
            นโยบายอาจเปลี่ยนแปลงไปตามที่บริษัทเป็นผู้กำหนด
            หากพยายามทุจริตหรือปลอมแปลงใดๆ จะมีกฏลงโทษแบนทันที
          </li>
        </div>
      </>
    );
  };

  return (
    <LayoutMaster
      content_setting={{
        title: "เกมติดโปร รวมเกมที่ติดเงื่อนไขโปรโมชั่น",
        description:
          "ทางเราได้จัดเตรียมเกมยอดนิยม สำหรับทุกท่านที่ทำงานสมัครโปรโมชั่น และ ทำ Turn/Over ให้ถึงที่กำหนดก็จะสามารถ ถอนเครดิต ออกไปใช้กันไปได้เลย",
      }}
      information={props.infomation}
    >
      <div className="container" style={{ paddingTop: 20 }}>
        <h1>
          <span>
            รวมเกมติดโปรโมชั่นยอดนิยม สำหรับสมาชิกที่ทำการสมัครโปรโมชั่น
          </span>
        </h1>

        {content.length == 0
          ? DisplayMainConent()
          : content.map((v, i) => {
              return (
                <div
                  key={i}
                  className="card color-font-card"
                  style={{ padding: 20, marginTop: 20 }}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: v.Html ?? "",
                    }}
                  ></div>
                </div>
              );
            })}

        <SectionCasinoGameBox
          imageType="normalv2"
          venderName={"เกมจากโปรโมชั่น ที่ทางเราได้เตรียมไว้สำหรับท่าน"}
          results={gamepromotions}
          titleBadge={"PROMO"}
          isFlagPromo={true}
        ></SectionCasinoGameBox>
        <div className="margin-top-20">
          <div className="border-radius shadow">
            <div className="card card-ufa-category color-font-card">
              <div className="heading margin-left-10 margin-right-10">
                <h4 className="font-bold">
                  <span>เงื่อนไขโปรโมชั่น</span>
                </h4>
                <p className="bottom-line-yellow"></p>
              </div>
              <div className="card-body">
                <li>
                  ท่านจะต้องทำเทิร์นโอเวอร์ให้ได้ตามโปรโมชั่นที่ท่านเลือกจนเสร็จสิ้นกิจกรรม
                  จึงจะสามารถถอนเครดิตได้
                </li>
                <li>
                  ในระหว่างที่ท่านกำลังใช้โปรโมชั่น
                  ท่านจะไม่สามารถทำการฝากเครดิตซ้ำได้จนกว่าจะเสร็จสิ้นเงื่อนไขกิจกรรม
                  หรือจนเครดิตของท่านจะเหลือน้อยกว่า 1 เครดิต
                </li>
                <li>
                  เมื่อเครดิตของท่านเหลือน้อยกว่า 1 เครดิต
                  ข้อผูกมัดจากกิจกรรมจะถูกยกเลิก
                </li>
                <li>
                  ท่านสามารถตรวจสอบการทำเทิร์นโอเวอร์ของท่านโดยตัวเองได้จากหน้าแรก
                </li>

                <li>
                  ท่านสามารถเล่นเกมที่อยู่ในเงื่อนไข โปรโมชั่น
                  ที่ทางเราได้จัดไว้ให้เท่านั้น
                </li>
                <li>
                  โดยเกมตามเงื่อนไขโปรโมชั่นจะปรากฏในหน้าแรก
                  เมื่อท่านได้เลือกใช้งานโปรโมชั่นแล้ว
                </li>
                <li>
                  ลักษณะหน้าตาของการติดโปรโมชั่น จะสังเกตุได้จากหน้าแรก
                  ซึ่งจะแสดงสถานะดังกล่าว
                  <div>
                    <div className="col-6">
                      <Badge>ติดโปร | 500.00 / 1000.00</Badge>
                      <ProgressBar
                        style={{ height: 20, marginTop: 3, marginBottom: 5 }}
                        now={50}
                        variant="danger"
                        animated
                        label={`50 %`}
                      />
                    </div>
                  </div>
                </li>
                <li className="font-red font-bold">
                  ท่านจะไม่สามารถเข้า เกม และ คาสิโน
                  ที่อยู่นอกเหนือโปรโมชั่นที่ทางเราจัดไว้ให้ได้ จนกว่าท่านจะทำ
                  Turn/Over ตามที่โปรโมชั่นกำหนด หรือ ยอดคงเหลือน้อยกว่า 1
                  เครดิต
                </li>
                <li className="font-red font-bold">
                  นโยบายอาจเปลี่ยนแปลงไปตามที่บริษัทเป็นผู้กำหนด
                  หากพยายามทุจริตหรือปลอมแปลงใดๆ จะมีกฏลงโทษแบนทันที
                </li>
                <li className="font-red font-bold">
                  หากพบปัญหาในการใช้งานโปรโมชั่น
                  กรุณาติดต่อเจ้าหน้าที่เพื่อรับทราบปัญหา
                </li>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayoutMaster>
  );
}

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  const infomation = CheckWithPrefix({ host: req.headers.host as string });
  try {
    const [gamepromotions, content] = await Promise.all([
      get_all_game_promotion_only({
        prefix: infomation.prefix,
      }),
      get_all_content_by_prefix({
        prefix: infomation.prefix,
      }),
    ]);

    return {
      props: {
        gamepromotions: gamepromotions,
        infomation: infomation,
        content: content.filter(
          (a) =>
            a.ContentTypeID == CONTENT_TYPE_ID_CONTENT_OTHER &&
            a.Title == CONTENT_HTML_TITLE_GAME_BOUNES
        ),
      },
    };
  } catch (error) {
    return {
      props: {
        gamepromotions: [],
        content: [],
        infomation: infomation,
      },
    };
  }
};

const mapStateToProps = (state: AppReducerStateProps) => {
  return {
    state: state,
  };
};

export default connect(mapStateToProps)(GameConditionPromotion);
